import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { Region, RegionClient, WorkingGroupClient, WorkingGroups } from "../../../../../web-api-client";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-workingGroups-creation',
  templateUrl: './workingGroups-creation.component.html',
  styleUrls: ['./workingGroups-creation.component.scss']
})
export class WorkingGroupsCreationComponent implements OnInit {

  public isLoaded = false;  // Ensure the form doesn't render until it's ready
  public regions: Region[] = [];
  public Form: FormGroup;

  public onClose = new Subject<boolean>();

  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal, private toastr: ToastrService, public client: WorkingGroupClient, public regionClient: RegionClient) { }

  ngOnInit(): void {
    this.initializeForm();  // Initialize the form first
    this.loadRegions();     // Then load regions
  }

  initializeForm() {
    this.Form = this.fb.group({
      title: ['', Validators.required],
      regionId: [null, Validators.required],  // Set default to null instead of 0 if nothing is selected
      isActive: [false]
    });
  }

  loadRegions() {
    this.regionClient.getList().subscribe((data) => {
      this.regions = data;
      this.isLoaded = true;  // Only set isLoaded to true after regions are loaded and form is ready
    });
  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }

  onSubmit() {
    if (this.Form.valid) {

      let service = new WorkingGroups();

      service.id = 0;
      service.title = this.Form.value.title;
      service.regionId = this.Form.value.regionId;
      service.isActive = this.Form.value.isActive;

      this.client.create(service).subscribe((user) => {
        this.toastr.success("Успешно Създадена", "Работна Група", {
          timeOut: 3000,
          closeButton: true,
          positionClass: "toast-top-right",
        });

        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

}
